import { AbstractControl, FormControl, FormGroup, ValidationErrors } from '@angular/forms';

import { snakeCase } from 'lodash-es';

import { flatten } from '@util/flatten';

export function getFormErrors(form: AbstractControl, depth: number = 1): ValidationErrors {
  const formErrors = getFormErrorsLoop(form);

  if (formErrors) {
    return flatten(formErrors, depth);
  } else {
    return null;
  }
}

function getFormErrorsLoop(form: AbstractControl): ValidationErrors {
  if (form instanceof FormControl) {
    return form.errors ?? null;
  }

  if (form instanceof FormGroup) {
    const groupErrors = form.errors;

    const errors = groupErrors ? { groupErrors } : {};

    for (const key of Object.keys(form.controls)) {
      const error = getFormErrorsLoop(form.get(key));

      if (error !== null) {
        errors[snakeCase(key)] = error;
      }
    }

    if (Object.keys(errors).length > 0) {
      return errors;
    } else {
      return null;
    }
  }

  return null;
}
